import { Button, Card } from "@blueprintjs/core";

type EventsGridToolbarProps = {
  onRefresh: () => void;
};

export function EventsGridToolbar({ onRefresh }: EventsGridToolbarProps) {
  return (
    <Card compact elevation={1}>
      <div className="flex flex-row grow">
        <h4 className="m-0 content-center bp6-heading">Events</h4>
        <div className="flex grow justify-end">
          <Button
            minimal
            intent="primary"
            text="Fetch Latest Events"
            icon="refresh"
            onClick={() => onRefresh()}
          />
        </div>
      </div>
    </Card>
  );
}
